<template>
    <div class="wx-container wx-container-flex">
        <div class="banner" v-if="detail && !requesting && detail.message_info.title">
            {{detail.message_info.title}}
        </div>
        <div :class="['scroll-container', detail.can_reply ? 'reply-container' : '']" v-if="!requesting && detail" style="margin-top: 15px;">
            <div class="scroll-content">
                <message-item :conversation="detail.send"></message-item>
                <div class="message-separate" v-if="detail.receive">
                    <div class="message-separate__line"></div>
                    <img src="@/assets/icons/reply-light.svg" class="message-separate__icon"/>
                    <div class="message-separate__line"></div>
                </div>
                <message-item :conversation="detail.receive" v-if="detail.receive"></message-item>
            </div>
        </div>
        <div class="reply-operation"
        :style="{bottom: `${keyboard_height}px`, transition: `all ease ${keyboard_duration}s`}"
        v-if="detail && detail.can_reply">
            <div class="reply-operation-container">
                <textarea
                v-model="message"
                class="operation-container__input"
                placeholder="请填写回复内容"
                maxlength="300"></textarea>
                <div class="operation-container__reply" @click="reply">
                    <div style="flex: 1">回复</div>
                </div>
            </div>
        </div>

        <div class="footer-operation" v-if="detail && detail.show_reply_button">
            <div class="operation-container">
                <div class="operation-container__btn message" @click="rereply">
                    <img src="@/assets/icons/paper-plane-sharp-light.svg" class="operation-container__btn_icon"/>
                    <div>回复</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { viewMessageDetail, sendMessage } from '@/interface/modules/message.api'
    import MessageItem from '@/components/Message/list-item'
    import token from '@/interface/utils/token'

    export default {
        components: { MessageItem },
        data () {
            return {
                requesting: false,
                message: '',
                detail: null,
                keyboard_height: 0,
                keyboard_duration: 0
            }
        },
        methods: {
            init () {
                const that = this
                this.requesting = true
                viewMessageDetail({
                    data: this.$route.params.id,
                    success: res => {
                        that.detail = res
                        that.requesting = false
                    },
                    fail: () => {
                        that.requesting = false
                        that.$router.replace({name: 'messageInbox'})
                    }
                })
            },
            reply () {
                const that = this
                sendMessage({
                    data: {
                        send_param: this.detail.message_info.send_param,
                        message: this.message
                    },
                    success: () => {
                        that.message = ''
                        that.init()
                    }
                })
            },
            rereply () {
                token.setValue('dialog', this.detail.message_info)
                this.$router.push({name: 'messageReply'})
            }
        },
        activated () {
            this.init()
        }
        // mounted () {
            
        // }
    }
</script>

<style lang="less" scoped>
    .reply-container {
        padding-bottom: 220px;
    }

    .message-separate {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0;
        .message-separate__line {
            flex: 1;
            height: 0;
            border-bottom: 1px solid #e3e3e3;
        }
        .message-separate__icon {
            width: 16px;
            height: 16px;
            opacity: .25;
            margin: 0 10px;
        }
    }
    .reply-operation {
        background-color: #fff;
        box-sizing: border-box;
        padding: 15px 15px 25px;
        position: fixed;
        left: 0;
        width: 100%;
        box-sizing: border-box;
        z-index: 10;
        .reply-operation-container {
            display: flex;
            align-items: flex-end;
            background-color: #f5f7fa;
            padding: 15px;
            border-radius: 4px;
            .operation-container__input {
                flex: 1;
                margin-right: 15px;
                min-height: 100px;
                max-height: 150px;
                border: none;
                border-radius: 4px;
                padding: 10px;
                box-sizing: border-box;
                background: transparent;
                outline: none;
            }
            .operation-container__reply {
                color: #08979C;
                font-size: 11pt;
                display: flex;
                align-items: center;
                .operation-container__reply_icon {
                    width: 14px;
                    height: 14px;
                    margin-right: 5px;
                }
            }
        }
    }
</style>


